// extracted by mini-css-extract-plugin
module.exports = {"logoCarousel":"styles_logoCarousel__V9JtI","copy":"styles_copy__L7uxr","logoContainer":"styles_logoContainer__EG_o0","scroll":"styles_scroll__WRXM_","logo":"styles_logo__vi0rH"};